const emailValidate = "^(([^<>()[\\]\\.,;:\\s@\"]+(\\.[^<>()[\\]\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$"

export const EditOrderModalList = [
    {
        label: "姓名",
        value: 'name',
        key: "name",
        placeholder: "請輸入姓名",
        required: true
    },
    {
        label: "電話",
        value: 'phone',
        key: "phone",
        placeholder: "請輸入電話",
        required: true
    },
    {
        label: "Email",
        value: 'email',
        key: "email",
        placeholder: "請輸入 Email",
        required: true
    },
    {
        label: "配送日期",
        value: 'deliveryDate',
        key: "deliveryDate",
        required: true,
        type: "date"
    },
    {
        label: "縣市",
        value: 'addressCity',
        key: "addressCity",
        placeholder: "請輸入縣市",
        required: true
    },
    {
        label: "城鎮",
        value: 'addressDistrict',
        key: "addressDistrict",
        placeholder: "請輸入鎮、區",
        required: true
    },
    {
        label: "詳細地址",
        value: 'addressDetailed',
        key: "addressDetailed",
        placeholder: "請輸入詳細地址",
        required: true
    },
    {
        label: "家具數量",
        value: 'furnitureCount',
        key: 'furnitureCount',
        type: "number",
        min: 1,
        placeholder: "請輸入家具數量",
        required: true
    },
    {
        label: "總重量(kg)",
        value: 'weight',
        key: "weight",
        min: 1,
        placeholder: "請輸入總重量",
        required: true
    },
    {
        label: "發票金額",
        value: 'invoiceAmount',
        key: "invoiceAmount",
        type: "number",
        min: 1,
        placeholder: "請輸入發票金額",
        required: true
    },
    {
        label: "運費",
        value: 'deliveryFee',
        key: "deliveryFee",
        type: "number",
        min: 0,
        placeholder: "請輸入運費",
        required: true
    },
]

export const CreateOrderModalList = [
    {
        label: "姓名",
        name: "name",
        type: "text",
        placeholder: "請輸入姓名",
        required: true
    },
    {
        label: "電話",
        name: "phone",
        type: "text",
        placeholder: "請輸入電話",
        required: true,
        pattern: "^09\\d{8}$",
        title: "未符合格式要求"
    },
    {
        label: "Email",
        name: "email",
        type: "email",
        placeholder: "請輸入 Email",
        required: true,
        pattern: emailValidate,
        title: "請確認email格式是否正確"
    },
    {
        label: "配送日期",
        name: "deliveryDate",
        type: "date",
        required: true
    },
    {
        label: "縣市",
        name: "addressCity",
        type: "text",
        placeholder: "請輸入縣市",
        required: true
    },
    {
        label: "城鎮",
        name: "addressDistrict",
        type: "text",
        placeholder: "請輸入鎮、區",
        required: true
    },
    {
        label: "詳細地址",
        name: "addressDetailed",
        type: "text",
        placeholder: "詳細地址",
        required: true
    },
    {
        label: "家具數量",
        name: "furnitureCount",
        type: "number",
        min: 1,
        placeholder: "請輸入家具數量",
        required: true
    },
    {
        label: "總重量(kg)",
        name: "weight",
        type: "number",
        min: 1,
        placeholder: "請輸入重量(kg)",
        required: true,
    },
    {
        label: "發票金額",
        name: "invoiceAmount",
        type: "number",
        min: 1,
        placeholder: "請輸入發票金額",
        required: true
    },
    {
        label: "運費",
        name: "deliveryFee",
        type: "number",
        min: 0,
        placeholder: "請輸入運費",
        required: true
    },
]